import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from '@rackd/ui';
import { routes } from './config/routes';
import { AuthProvider } from './features/auth/AuthProvider';
import { AdminRoute } from './features/auth/AdminRoute';
import { AdminLayout } from './components/AdminLayout';

// Pages
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { CatalogPage } from './pages/CatalogPage';
import { ModerationPage } from './pages/ModerationPage';

export function App() {
  return (
    <BrowserRouter>
      <ToastProvider position="top-right">
        <AuthProvider>
          <Routes>
          {/* Public routes */}
          <Route path={routes.login} element={<LoginPage />} />

          {/* Protected admin routes */}
          <Route
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path={routes.reviews} element={<ReviewsPage />} />
            <Route path={routes.users} element={<UsersPage />} />
            <Route path={routes.userDetail} element={<UserDetailPage />} />
            <Route path={routes.catalog} element={<CatalogPage />} />
            <Route path={routes.moderation} element={<ModerationPage />} />
          </Route>

          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to={routes.dashboard} replace />} />
        </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
